import { QuizQuestion } from "../../shared/types";
import {
  TrendingUp,
  TrendingDown,
  TrendingFlat,
  Assignment,
  Analytics,
  Visibility,
  VisibilityOff,
  Campaign,
  QuestionMark,
  Lightbulb,
  Build,
  Settings,
  Engineering,
  Memory,
  Groups,
  Person,
  GroupWork,
  EmojiEvents,
  Star,
  ThumbUp,
  ThumbDown,
  Assessment,
  Schedule,
  Timer,
  HelpOutline,
  Psychology,
  BugReport,
  Error,
  Warning,
  PriorityHigh,
  WorkOff,
  MonetizationOn,
  Celebration,
  Mood,
  SentimentDissatisfied,
} from "@mui/icons-material";

export const businessAuditQuestions: QuizQuestion[] = [
  {
    question: "What best describes your current business performance?",
    options: [
      { text: "We're growing consistently", icon: TrendingUp },
      { text: "We're growing, but it feels harder than it should", icon: TrendingFlat },
      { text: "We're stuck at the same level for a while now", icon: Assignment },
      { text: "We're losing customers or sales", icon: TrendingDown },
    ],
  },
  {
    question: "How confident are you that your current marketing is working?",
    options: [
      { text: "We know it's working and have clear ROI", icon: Analytics },
      { text: "We think it's working, but can't prove it", icon: Visibility },
      { text: "It's hit or miss — sometimes it works, sometimes not", icon: VisibilityOff },
      { text: "It's not getting results at all", icon: Campaign },
    ],
  },
  {
    question: "When customers first find you, what impression do you think they get?",
    options: [
      { text: "Our brand looks sharp and modern", icon: Star },
      { text: "It's fine, but could be better", icon: ThumbUp },
      { text: "It's outdated or unclear", icon: ThumbDown },
      { text: "I have no idea what they think", icon: QuestionMark },
    ],
  },
  {
    question: "How clear and compelling is your main product or service offer?",
    options: [
      { text: "Very clear and customers love it", icon: Lightbulb },
      { text: "It's somewhat clear, but needs refining", icon: Build },
      { text: "It's confusing or not resonating with people", icon: Settings },
      { text: "We have multiple offers, and none are working well", icon: Engineering },
    ],
  },
  {
    question: "Are your systems and processes helping or holding you back?",
    options: [
      { text: "Everything runs smoothly and efficiently", icon: Memory },
      { text: "Some bottlenecks, but manageable", icon: Settings },
      { text: "Lots of manual or inefficient tasks", icon: Build },
      { text: "It's chaotic — no real systems in place", icon: BugReport },
    ],
  },
  {
    question: "Do your employees or team members clearly know what success looks like?",
    options: [
      { text: "Yes — they're aligned and goal-focused", icon: Groups },
      { text: "Somewhat — goals exist but not tracked", icon: GroupWork },
      { text: "No — there's confusion or low accountability", icon: HelpOutline },
      { text: "It's just me running the show", icon: Person },
    ],
  },
  {
    question: "What best describes your customer experience?",
    options: [
      { text: "Customers love us and refer others", icon: EmojiEvents },
      { text: "We get decent reviews, but no raving fans", icon: Star },
      { text: "Customers complain or churn often", icon: SentimentDissatisfied },
      { text: "We've never measured customer experience", icon: Assessment },
    ],
  },
  {
    question: "How often do you track performance or results across your business?",
    options: [
      { text: "Weekly or monthly with clear metrics", icon: Schedule },
      { text: "Occasionally, when something feels off", icon: Timer },
      { text: "Rarely — we mostly go by gut feeling", icon: Psychology },
      { text: "Never — we don't track this", icon: VisibilityOff },
    ],
  },
  {
    question: "When something goes wrong in your business, how do you usually respond?",
    options: [
      { text: "We quickly identify and fix the root cause", icon: Engineering },
      { text: "We patch the issue temporarily", icon: Build },
      { text: "We're usually not sure why it happened", icon: Warning },
      { text: "We ignore it until it becomes a big problem", icon: Error },
    ],
  },
  {
    question: "What's your biggest frustration as a business owner right now?",
    options: [
      { text: "We're working hard but not seeing real results", icon: WorkOff },
      { text: "Marketing or sales just aren't converting", icon: MonetizationOn },
      { text: "Our operations or team aren't running well", icon: Settings },
      { text: "I feel stuck and don't know what to fix first", icon: PriorityHigh },
    ],
  },
];
